module.exports = __webpack_public_path__ + "img/logo-siasn.8dbca5b2.png";